'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var pageSlicer = exports.pageSlicer = function pageSlicer(catalog, count) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    if (count === 'all' || typeof count === 'undefined') {
        return catalog;
    }
    var pages = Math.ceil(catalog.length / count);
    var currentPage = page;
    if (page > pages) {
        currentPage = pages;
    }
    var start = (currentPage - 1) * count;
    return catalog.slice(start, start + count);
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/pagination.js
// module id = 7oYi
// module chunks = 46